import { getStorageItem, setStorageItem, WebStorageType } from "../../../../common-deprecated/utils/storageUtils";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { NavOrigin } from "../../shared-logic/utils/Navigation";

// ----------------------------------------------------------------------
// Helper Types and consts
// ----------------------------------------------------------------------
const SESSION_STORAGE_ID = "onlineRetail.build";

type BuildSessionStorageParams = {
    country: string;
    language: string;
};

type BuildSessionStorageItemType = {
    taxLocationId?: string;
    navigationOrigin?: NavOrigin;
};

// ----------------------------------------------------------------------
// Storage fns
// ----------------------------------------------------------------------
export const setBuildSessionStorage = (
    params: BuildSessionStorageParams,
    storageItems: BuildSessionStorageItemType,
): void => {
    setStorageItem({ ...params, storageId: SESSION_STORAGE_ID }, storageItems, WebStorageType.session);
};

export const getBuildSessionStorage = (params: BuildSessionStorageParams): BuildSessionStorageItemType | null => {
    return getStorageItem({ ...params, storageId: SESSION_STORAGE_ID }, WebStorageType.session);
};

// ----------------------------------------------------------------------
// Tax Location
// ----------------------------------------------------------------------
export const getTaxLocationIdFromStorage = (params: BuildSessionStorageParams): string => {
    return getBuildSessionStorage(params)?.taxLocationId || "";
};

export const setTaxLocationIdToStorage = (params: BuildSessionStorageParams, taxLocationId: string): void => {
    setBuildSessionStorage(params, { taxLocationId });
};

// ----------------------------------------------------------------------
// Navigation Origin
// ----------------------------------------------------------------------
export const getNavigationOriginFromStorage = (params: BuildSessionStorageParams): NavOrigin => {
    return getBuildSessionStorage(params)?.navigationOrigin || NavOrigin.Unknown;
};

export const setNavigationOriginToStorage = (params: BuildSessionStorageParams, navigationOrigin: NavOrigin): void => {
    setBuildSessionStorage(params, { navigationOrigin });
};

// ----------------------------------------------------------------------
// Helper fns
// ----------------------------------------------------------------------

export const getSessionStorageParams = (commonSettings: CommonSettingsType): BuildSessionStorageParams => ({
    country: commonSettings.country,
    language: commonSettings.language,
});
